/**
 * Privacy legal document sheet (global menu) — BaseModal tuning.
 */

export const PRIVACY_LEGAL_DOCUMENT_MODAL = {
  BASE_MODAL_BLUR_INTENSITY: 22,
} as const;

export const PRIVACY_LEGAL_DOCUMENT_MODAL_TEST_ID = 'privacy-legal-document-modal';
export const PRIVACY_LEGAL_DOCUMENT_MODAL_CONTENT_TEST_ID =
  'privacy-legal-document-modal-content';
